import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../app';
import SelectDropdown from '../../common/components/SelectDropdown';
import Button from '../../common/components/Button';
import saveSettings from '../utils/saveSettings';
export default class SettingDropdown extends SelectDropdown {
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    attrs.className = 'SettingDropdown';
    attrs.buttonClassName = 'Button Button--text';
    attrs.caretIcon = 'fas fa-caret-down';
    attrs.defaultLabel || (attrs.defaultLabel = app.translator.trans('core.admin.settings.select_dropdown_custom_label'));
    if ('key' in attrs) {
      var _attrs$key;
      attrs.setting = (_attrs$key = attrs.key) == null ? void 0 : _attrs$key.toString();
      delete attrs.key;
    }
  }
  view(vnode) {
    return super.view(_objectSpread(_objectSpread({}, vnode), {}, {
      children: this.attrs.options.map(_ref => {
        var _app$data$settings;
        let {
          value,
          label
        } = _ref;
        const active = ((_app$data$settings = app.data.settings[this.attrs.setting]) != null ? _app$data$settings : this.attrs.default) === value;
        return m(Button, {
          icon: active ? 'fas fa-check' : true,
          onclick: saveSettings.bind(this, {
            [this.attrs.setting]: value
          }),
          active: active
        }, label);
      })
    }));
  }
}
flarum.reg.add('core', 'admin/components/SettingDropdown', SettingDropdown);